import React, { useEffect, useRef } from 'react';
import { extractOtpCode } from '../utils/otpAutofill';

const OTP_LENGTH = 6;

export default function OtpInput({
  value = '',
  onChange,
  onComplete,
  disabled = false,
  autoFocus = false,
  hint,
}) {
  const inputRef = useRef(null);
  const code = extractOtpCode(value).slice(0, OTP_LENGTH);
  const activeIndex = Math.min(code.length, OTP_LENGTH - 1);

  const applyCode = (raw) => {
    const next = extractOtpCode(raw).slice(0, OTP_LENGTH);
    onChange?.(next);
    if (next.length === OTP_LENGTH) onComplete?.(next);
  };

  useEffect(() => {
    if (!autoFocus || disabled) return undefined;
    const timer = setTimeout(() => inputRef.current?.focus(), 120);
    return () => clearTimeout(timer);
  }, [autoFocus, disabled]);

  const focusInput = () => {
    if (!disabled) inputRef.current?.focus();
  };

  return (
    <div className="otp-field">
      <div
        className="otp-row otp-row--display"
        onClick={focusInput}
        onKeyDown={(e) => e.key === 'Enter' && focusInput()}
        role="presentation"
      >
        {Array.from({ length: OTP_LENGTH }, (_, i) => {
          const digit = code[i] || '';
          const isActive = !disabled && i === activeIndex;
          return (
            <div
              key={i}
              className={`otp-box otp-box--display${digit ? ' otp-box--filled' : ''}${isActive ? ' otp-box--active' : ''}`}
              aria-hidden="true"
            >
              {digit}
            </div>
          );
        })}
      </div>
      <input
        ref={inputRef}
        className="otp-field__input"
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="one-time-code"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        enterKeyHint="done"
        maxLength={OTP_LENGTH}
        value={code}
        disabled={disabled}
        aria-label="One-time password"
        onChange={(e) => applyCode(e.target.value)}
        onPaste={(e) => {
          e.preventDefault();
          applyCode(e.clipboardData.getData('text'));
        }}
      />
      {hint ? <p className="otp-field__hint">{hint}</p> : null}
    </div>
  );
}
